import Tabs from '@cas/components/tabs/tabs/Tabs';
import useTabs, { TabConfig } from '@cas/components/tabs/tabs/useTabs';
import { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import InvestigationNotes from '../investigation-notes/InvestigationNotes';
import { VdsCard } from '@volt/volt-extended-components-react';
import styles from './TabbedContent.module.scss';
import InvestigationRawTracks from '../raw-tracks/InvestigationRawTracks';
import InvestigationSummary from '../investigation-summary/InvestigationSummary';
import { AssetInvestigationType } from '@customer/store/apis/investigationsApi';

interface TabbedContentProps {
  investigationType: AssetInvestigationType;
}

export const TabbedContent = ({ investigationType }: TabbedContentProps): ReactElement => {
  const { t } = useTranslation();

  const tabConfigs = useMemo<TabConfig[]>(() => {
    const commonTabs: TabConfig[] = [
      { title: t('Tracks'), view: <InvestigationRawTracks /> },
      { title: t('Notes'), view: <InvestigationNotes /> },
    ];

    if (investigationType !== AssetInvestigationType.Custom) {
      return [{ title: t('Summary'), view: <InvestigationSummary /> }, ...commonTabs];
    } else {
      return commonTabs;
    }
  }, [t, investigationType]);

  const { activeView, ...tabsProps } = useTabs({ tabConfigs });

  return (
    <div className={styles.wrapper}>
      <Tabs {...tabsProps} hasBorder />
      <VdsCard className={styles.card} padding="spacing-00">
        <div className={styles.container}>{activeView}</div>
      </VdsCard>
    </div>
  );
};

export default TabbedContent;
